import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const location = useLocation();

  if (!token) return <Navigate to="/" />;

  const rawPercent = localStorage.getItem("profileCompletionPercent");
  if (rawPercent !== null) {
    const completionPercent = Number(rawPercent);
    const isComplete = Number.isFinite(completionPercent) && completionPercent >= 100;
    if (!isComplete && location.pathname !== "/viewProfile") {
      sessionStorage.setItem("showProfileGateToast", "1");
      return <Navigate to="/viewProfile" replace />;
    }
  }

  return <>{children}</>;
};

export default PrivateRoute;
